export default "__VITE_ASSET__CBRtUjTa__"